import { Moment } from 'moment';
import { TargetLanguage } from './target-language';
import { BloodType } from './blood-type';
import { Frequency } from './frequency';
import { Booking } from './booking';

export class Vademecum {

    constructor(
        public streetName: string,
        public streetNumber: string,
        public city: string,
        public postCode: string,
        public birthDate: Moment,
        public targetLanguage: TargetLanguage,
        public doctorName: string,
        public doctorPhoneNumber: string,
        public experiencedDiseases: string,
        public hasDiabetes: boolean,
        public hasAsthma: boolean,
        public hasHeartTrouble: boolean,
        public hasEpilepsy: boolean,
        public hasRheumatism: boolean,
        public hasPhysicalDisability: boolean,
        public hasSkinAffection: boolean,
        public hasSleepDisorder: boolean,
        public otherDiseases: string,
        public lastSkinTestDate: Moment,
        public skinTestPositive: boolean,
        public hadTetanusVaccination: boolean,
        public tetanusBoosterYear: number,
        public hasAllergiesToMedicines: boolean,
        public allergiesCauseMedicine: string,
        public hasAllergiesToSubstances: boolean,
        public allergiesCauseSubstance: string,
        public isIncontinent: boolean,
        public isQuicklyTired: boolean,
        public isSensitiveToChilling: boolean,
        public canSportWithoutRisk: boolean,
        public needMedicalTreatment: boolean,
        public medicinesQuantity: string,
        public bloodType: BloodType,
        public otherInformations: string,
        public emergencyContactAddress: string,

        public hasMentalDisorder: boolean,
        public mentalDisorderDescription: string,
        public riskDescriptionToSport: string,
        public studyDutchInSchool: boolean,
        public studyEnglishInSchool: boolean,
        public studyFrenchInSchool: boolean,
        public dutchStudyYears: number,
        public englishStudyYears: number,
        public frenchStudyYears: number,
        public dutchStudyHours: number,
        public englishStudyHours: number,
        public frenchStudyHours: number,
        public frequencySpeakingWithFamily: Frequency,
        public frequencySpeakingWithFriends: Frequency,
        public hasLearningDifficulty: boolean,
        public hadLanguageTest: boolean,
        public languageTestDate: Moment,
        public matterToReview: string,
        public studyBookName: string,
        public dutchTeacherName: string,
        public englishTeacherName: string,
        public frenchTeacherName: string,
        public isComingWithFriends: boolean,
        public friendName: string,
        public booking: Booking | null,
        public studentMobile: string | null,
        public firstParentMobile: string,
        public secondParentMobile: string | null,
        public firstParentFirstName: string,
        public firstParentLastName: string,
        public secondParentFirstName: string | null,
        public secondParentLastName: string | null,
        public id?: number | null,
        public agreeWithTerms?: boolean,
        public agreeToTakeStudentPicture?: boolean
    ){}
}
